import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { primaryColor, secondaryFont, wMedium } from 'Utils/utilsStyle';

const Wrapper = styled.div`
width: 100%;
display: flex;
justify-content: space-between;
border-top: 0.6px solid #CACACA;
border-bottom: 0.6px solid #CACACA;
.tab-title {
  display: flex;
  justify-content: center;
  width: 33.33%;
  padding: 10px 0px;
  font-family: ${secondaryFont};
  font-size: 16px;
  font-weight: ${wMedium};
  line-height: 20px;
  letter-spacing: -0.625px;
  color: #667982;
  cursor: pointer;
  &.active {
    color: ${primaryColor};
    border-bottom: 2px solid ${primaryColor};
  }
}
`;

type Props = {
  activeTab: number,
  setActiveTab: (a: number) => void,
  setIsNotBuyerCommeittee: (a: boolean) => void,
};

const SmartAccountTabs = function SmartAccountTabs(props: Props) {
  const { activeTab, setActiveTab, setIsNotBuyerCommeittee } = props;
  return (
    <Wrapper>
      <span className={classNames('tab-title', { active: activeTab === 0 })} onClick={() => { setIsNotBuyerCommeittee(true); setActiveTab(0); }} role="button" onKeyPress={() => { }} tabIndex={0}>
        Job Titles
      </span>
      <span className={classNames('tab-title', { active: activeTab === 1 })} onClick={() => { setActiveTab(1); }} role="button" onKeyPress={() => { }} tabIndex={0}>
        People
      </span>
      <span className={classNames('tab-title', { active: activeTab === 2 })} onClick={() => { setActiveTab(2); }} role="button" onKeyPress={() => { }} tabIndex={0}>
        Buyer Group
      </span>
    </Wrapper>
  );
};

export default SmartAccountTabs;
